<template>
  <PTransparentLoader :loading="loading" class="event-wizard">
    <CContainer class="p-0">
      <h1 class="main-header mb-1" v-translate translate-context="event_wizard">Privacy</h1>
      <p>
        <translate translate-context="event_wizard.subtitle">
          Enable and choose custom privacy settings for your users
        </translate>
      </p>

      <PFRow size="5x7" :label="$pgettext('event_wizard.label', 'Privacy policy')"
             :help-text="$pgettext('event_wizard.help', 'Select from a pre-existing setting')"
             separator
             label-class="big">
        <multiselect
            class="mb-2"
            :options="privacyPolicyTypeOptions"
            label="label"
            :searchable="false"
            track-by="value"
            :value="privacyPolicySelected"
            @input="(event) => v$.form.privacy_policy_type.$model = event.value"
            @select="previewFieldUpdated"
            :allow-empty="false"
            :show-labels="false"
        />
      </PFRow>

      <PFRow size="5x7" :label="$pgettext('event_wizard.label', 'Checkbox')"
             :help-text="$pgettext('event_wizard.help', 'Make the field mandatory')"
             separator
             label-class="big" v-if="!isPrivacyPolicyManagedByPica">
        <CSwitch color="primary"
                 variant="3d" size="sm"
                 @update:checked="previewFieldUpdated"
                 :checked.sync="v$.form.show_privacy_checkbox.$model"/>

      </PFRow>
      <PFRow size="5x7" v-if="isCustomPrivacyPolicy" :label="$pgettext('event_wizard.label', 'Content')"
             label-class="big"
             separator
             :help-text="$pgettext('event_wizard.help', 'Create your own custom privacy text for the event')">
        <PTranslatableCkeditor
            v-model="v$.form.privacy_policy_text.$model"
            @input="previewFieldUpdated"
            :placeholder="$pgettext('event_wizard.placeholder','Privacy Link')"
        />

      </PFRow>
      <PFRow :label="$pgettext('event_wizard.label', 'Share e-mail privacy policy')"
             separator
             label-class="big" size="5x7">
        <multiselect
            class="mb-2"
            :options="sharePolicyTypeOptions"
            label="label"
            track-by="value"
            :searchable="false"
            :value="sharePolicySelected"
            @input="(event) => v$.form.share_policy_type.$model = event.value"
            @select="previewFieldUpdated"
            :allow-empty="false"
            :show-labels="false"
        />
      </PFRow>
      <PFRow size="5x7" :label="$pgettext('event_wizard.label', 'Content')"
             :help-text="$pgettext('event_wizard.help', 'Create your own custom share privacy text for the event')"
             separator
             label-class="big" v-if="isCustomSharePolicy">
        <PTranslatableCkeditor
            v-model="v$.form.share_policy_text.$model"
            @input="previewFieldUpdated"
            :placeholder="$pgettext('event_wizard.placeholder','Share policy Link')"
        />
      </PFRow>
      <PFRow full-width v-if="sharePolicyIsEnabled" separator>
        <PButton
            color="primary"
            class="mr-3"
            :loading="shareDataInDownload"
            @click="downloadShareData">
          <translate translate-context="event_wizard">Show share policy</translate>
        </PButton>
      </PFRow>

      <PFRow :label="$pgettext('event_wizard.label', 'Privacy policy 2')"
             separator
             label-class="big" size="5x7">
        <multiselect
            class="mb-2"
            :options="privacyPolicyTypeOptions2"
            label="label"
            track-by="value"
            :searchable="false"
            :value="sharePolicy2Selected"
            @input="(event) => v$.form.share_policy2_type.$model = event.value"
            @select="previewFieldUpdated"
            :allow-empty="false"
            :show-labels="false"
        />
      </PFRow>
      <PFRow size="5x7" :label="$pgettext('event_wizard.label', 'Content')"
             :help-text="$pgettext('event_wizard.help', 'Create your own custom privacy policy 2 text for the event')"
             separator
             label-class="big" v-if="isCustomSharePolicy2 && showSharePolicy2">
        <PTranslatableCkeditor
            v-model="v$.form.share_policy2_text.$model"
            @input="previewFieldUpdated"
            :placeholder="$pgettext('event_wizard.placeholder','Privacy policy 2 text')"
        />
      </PFRow>

      <PFRow :label="$pgettext('event_wizard.label', 'Privacy policy 3')"
             separator
             label-class="big" size="5x7" v-if="showSharePolicy3">
        <multiselect
            class="mb-2"
            :options="privacyPolicyTypeOptions3"
            label="label"
            track-by="value"
            :searchable="false"
            :value="sharePolicy3Selected"
            @input="(event) => v$.form.share_policy3_type.$model = event.value"
            @select="previewFieldUpdated"
            :allow-empty="false"
            :show-labels="false"
        />
      </PFRow>
      <PFRow size="5x7" :label="$pgettext('event_wizard.label', 'Content')"
             :help-text="$pgettext('event_wizard.help', 'Create your own custom privacy policy 3 text for the event')"
             separator
             label-class="big" v-if="isCustomSharePolicy3 && showSharePolicy3">
        <PTranslatableCkeditor
            v-model="v$.form.share_policy3_text.$model"
            @input="previewFieldUpdated"
            :placeholder="$pgettext('event_wizard.placeholder','Privacy policy 3 text')"
        />
      </PFRow>

      <h1 class="main-header mb-1" v-translate translate-context="event_wizard">Checkin</h1>
      <PFRow size="5x7" :label="$pgettext('event_wizard.label', 'Pre Selfie Text')"
             :help-text="$pgettext('event_wizard.help', 'Custom text pre-selfie')"
             separator
             label-class="big">
        <PTranslatableCkeditor
            v-model="v$.form.pre_selfie_text.$model"
            @input="previewFieldUpdated"
            :placeholder="$pgettext('event_wizard.placeholder','Custom text pre-selfie')"
        />
      </PFRow>

      <h1 class="main-header mb-1" v-translate translate-context="event_wizard">Payment</h1>
      <PFRow size="5x7" :label="$pgettext('event_wizard.label', 'Pre Payment Confirm Text')"
             :help-text="$pgettext('event_wizard.help', 'If present, this text will show the message and ask for confirmation before accepting an order')"
             separator
             label-class="big">
        <PTranslatableCkeditor
            v-model="v$.form.pre_payment_confirm_text.$model"
            @input="previewFieldUpdated"
            :placeholder="$pgettext('event_wizard.placeholder','Custom pre payment confirm text')"
        />
      </PFRow>
      <h1 class="main-header mb-1" v-translate translate-context="event_wizard">E-Mail customization</h1>
      <PFRow size="5x7" :label="$pgettext('event_wizard.label', 'Credit - EMail')"
             :help-text="$pgettext('event_wizard.help', 'The field will be sent in the email to be used based on the template')"
             separator
             label-class="big">
        <CInput v-model="v$.form.credit_email.$model" @input="previewFieldUpdated"/>
      </PFRow>
      <PFRow size="5x7" :label="$pgettext('event_wizard.label', 'Credit - Name')"
             :help-text="$pgettext('event_wizard.help', 'The field will be sent in the email to be used based on the template')"
             separator
             label-class="big">
        <CInput v-model="v$.form.credit_name.$model" @input="previewFieldUpdated"/>
      </PFRow>
    </CContainer>

    <div class="event-wizard__footer">
      <CRow>
        <CCol>
          <div class="d-flex justify-content-end">
            <div class="mr-2">
              <CButton color="secondary" block @click="onReset" ref="reset-button"
                       v-translate translate-context="event_wizard">
                Reset
              </CButton>
            </div>
            <div>
              <CButton color="primary" @click="onSave" block :disabled="v$.$invalid" ref="save-button"
                       v-translate translate-context="event_wizard">
                Save
              </CButton>
            </div>
          </div>
        </CCol>
      </CRow>
    </div>
  </PTransparentLoader>
</template>

<script>
import {useVuelidate} from "@vuelidate/core";
import {required, requiredIf} from "@vuelidate/validators";
import Multiselect from "vue-multiselect";
import PTranslatableCkeditor from "@/domain/core/components/PTranslatableCkeditor.vue";
import PTransparentLoader from "@/domain/core/components/PTransparentLoader.vue";
import PButton from "@/components/PButton.vue";
import PFRow from "@/domain/core/components/PFRow.vue";
import {mapActions, mapGetters} from "vuex";

// Privacy policy type constants
const PRIVACY_POLICY_TYPES = {
  NONE: 'none',
  MANDATORY: 'mandatory',
  OPTIONAL: 'optional'
};

export default {
  name: "StepCustomization",
  components: {PFRow, PButton, PTransparentLoader, PTranslatableCkeditor, Multiselect},
  props: {
  },
  data() {
    return {
      form: {
        privacy_policy_type: null,
        show_privacy_checkbox: false,
        privacy_policy_text: {
          it: '',
          en: '',
        },
        share_policy_type: null,
        share_policy_text: {
          it: '',
          en: '',
        },
        share_policy2_type: PRIVACY_POLICY_TYPES.NONE,
        share_policy2_text: {
          it: '',
          en: '',
        },
        share_policy3_type: PRIVACY_POLICY_TYPES.NONE,
        share_policy3_text: {
          it: '',
          en: '',
        },
        pre_selfie_text: {
          it: '',
          en: '',
        },
        pre_payment_confirm_text: {
          it: '',
          en: '',
        },
        credit_name: null,
        credit_email: null,
      },
      shareDataInDownload: false,
    }
  },
  emits: ['save', 'updatePreview', 'downloadShareData'],
  setup() {
    return {v$: useVuelidate()}
  },
  async mounted() {
    if (!this.step_customization) {
      await this.fetchStepData('customization')
      this.onReset()
    } else {
      this.onReset()
    }
  },
  computed: {
    ...mapGetters('eventWizard', [
      'step_customization',
      'isStepLoading'
    ]),
    loading() {
      return this.isStepLoading('customization')
    },
    privacyPolicyTypeOptions() {
      return [
        {label: this.$pgettext('event_wizard.label', 'Pica is the privacy manager'), value: 'pica'},
        {
          label: this.$pgettext('event_wizard.label', 'Use the default privacy policy text'),
          value: 'event_owner'
        },
        {label: this.$pgettext('event_wizard.label', 'Use custom privacy policy for this event'), value: 'custom'},
      ]
    },
    sharePolicyTypeOptions() {
      return [
        {label: this.$pgettext('event_wizard.label', 'User e-mail will remain private'), value: 'no_share'},
        {
          label: this.$pgettext('event_wizard.label', 'Use the default share policy text'),
          value: 'event_owner'
        },
        {label: this.$pgettext('event_wizard.label', 'Use custom share policy for this event'), value: 'custom'},
      ]
    },
    privacyPolicyTypeOptions2() {
      return [
        {label: this.$pgettext('event_wizard.label', 'None'), value: PRIVACY_POLICY_TYPES.NONE},
        {label: this.$pgettext('event_wizard.label', 'Mandatory'), value: PRIVACY_POLICY_TYPES.MANDATORY},
        {label: this.$pgettext('event_wizard.label', 'Optional'), value: PRIVACY_POLICY_TYPES.OPTIONAL},
      ]
    },
    privacyPolicyTypeOptions3() {
      return [
        {label: this.$pgettext('event_wizard.label', 'None'), value: PRIVACY_POLICY_TYPES.NONE},
        {label: this.$pgettext('event_wizard.label', 'Mandatory'), value: PRIVACY_POLICY_TYPES.MANDATORY},
        {label: this.$pgettext('event_wizard.label', 'Optional'), value: PRIVACY_POLICY_TYPES.OPTIONAL},
      ]
    },
    isPrivacyPolicyManagedByPica() {
      return this.form.privacy_policy_type === 'pica'
    },
    isCustomPrivacyPolicy() {
      return this.form.privacy_policy_type === 'custom'
    },
    isCustomSharePolicy() {
      return this.form.share_policy_type === 'custom'
    },
    sharePolicyIsEnabled() {
      return this.form.share_policy_type !== 'no_share'
    },
    privacyPolicySelected() {
      return this.privacyPolicyTypeOptions.find(o => o.value === this.form.privacy_policy_type)
    },
    sharePolicySelected() {
      return this.sharePolicyTypeOptions.find(o => o.value === this.form.share_policy_type)
    },
    sharePolicy2Selected() {
      return this.privacyPolicyTypeOptions2.find(o => o.value === this.form.share_policy2_type)
    },
    sharePolicy3Selected() {
      return this.privacyPolicyTypeOptions3.find(o => o.value === this.form.share_policy3_type)
    },
    showSharePolicy2() {
      return this.form.share_policy2_type !== PRIVACY_POLICY_TYPES.NONE
    },
    showSharePolicy3() {
      return this.form.share_policy2_type !== PRIVACY_POLICY_TYPES.NONE
    },
    isCustomSharePolicy2() {
      return this.form.share_policy2_type === PRIVACY_POLICY_TYPES.OPTIONAL || this.form.share_policy2_type === PRIVACY_POLICY_TYPES.MANDATORY
    },
    isCustomSharePolicy3() {
      return this.form.share_policy3_type === PRIVACY_POLICY_TYPES.OPTIONAL || this.form.share_policy3_type === PRIVACY_POLICY_TYPES.MANDATORY
    },
  },
  validations() {
    return {
      form: {
        privacy_policy_type: {required},
        share_policy_type: {required},
        share_policy2_type: {},
        share_policy3_type: {},
        show_privacy_checkbox: {},
        privacy_policy_text: {requiredIf: requiredIf(() => this.isCustomPrivacyPolicy)},
        share_policy_text: {requiredIf: requiredIf(() => this.isCustomSharePolicy)},
        share_policy2_text: {requiredIf: requiredIf(() => this.isCustomSharePolicy2 && this.showSharePolicy2)},
        share_policy3_text: {requiredIf: requiredIf(() => this.isCustomSharePolicy3 && this.showSharePolicy3)},
        pre_selfie_text: {},
        pre_payment_confirm_text: {},
        credit_name: {},
        credit_email: {},
      }
    }
  },

  methods: {
    ...mapActions('eventWizard', [
      'fetchStepData'
    ]),
    onReset() {
      this.form = {
        ...this.step_customization,
        share_policy2_type: this.step_customization.share_policy2_type || PRIVACY_POLICY_TYPES.NONE,
        share_policy2_text: this.step_customization.share_policy2_text || {
          it: '',
          en: '',
        },
        share_policy3_type: this.step_customization.share_policy3_type || PRIVACY_POLICY_TYPES.NONE,
        share_policy3_text: this.step_customization.share_policy3_text || {
          it: '',
          en: '',
        },
      }
      this.previewFieldUpdated()
    },

    async onSave() {
      if (!await this.v$.$validate()) return
      await this.emitPromised('save', this.form)
      this.onReset()
    },

    async previewFieldUpdated() {
      await this.$nextTick()
      this.$emit('updatePreview', {
        privacy_policy_type: this.form.privacy_policy_type,
        privacy_policy_text: this.form.privacy_policy_type == 'event_owner' ? {'it': 'Privacy policy settata a livello di event owner..'} : this.form.privacy_policy_text,
        show_privacy_checkbox: this.form.privacy_policy_type == 'pica' ? false : this.form.show_privacy_checkbox,
        share_policy_type: this.form.privacy_policy_type,
        share_policy_text: this.form.share_policy_text,
        share_policy2_type: this.form.share_policy2_type,
        share_policy2_text: this.form.share_policy2_text,
        share_policy3_type: this.form.share_policy3_type,
        share_policy3_text: this.form.share_policy3_text,
        pre_selfie_text: this.form.pre_selfie_text,
        pre_payment_confirm_text: this.form.pre_payment_confirm_text,
        credit_name: this.form.credit_name,
        credit_email: this.form.credit_email,
      })
    },

    async downloadShareData() {
      this.shareDataInDownload = true
      await this.$emit('downloadShareData')
      this.shareDataInDownload = false
    }
  }
}
</script>

<style scoped>

</style>
